import { NgModule }              from '@angular/core';
import { PopupsRoutingModule }   from './popups-routing.moule';

import { SharedModule }          from '../shared/shared.module';
import { PopupComponent }        from './popup/popup.component';
import { LoginComponent }        from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthInputComponent }    from './input/input.component';

@NgModule({
  imports: [
    PopupsRoutingModule,
    SharedModule
  ],
  declarations: [
    PopupComponent,
    LoginComponent,
    RegistrationComponent,
    ForgotPasswordComponent,
    AuthInputComponent
  ]
})
export class PopupsModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/popups/popups.moule.ts